<style>

.card{
  position: relative;
  color: white;
}

img{
  object-fit: cover;
  width: 100%;
}

.info{
  position: absolute;
  bottom: 20px;
  left: 0;
  right: 0;
  padding: 5px;
  /* border: 1px red solid; */
  /* margin-top: -40px; */
  background-color: rgba(0,0,0,0.8);
}
.name{
  font-size: 25px;
}


.popup{
  position: fixed;
  z-index: 50;
  left: 0;
  right: 0;
  bottom: 0;
  height: 260px;
  background-color: rgba(0,0,0,1);
  /* box-shadow: 0 -2px 5px rgb(255,255,255,0.5); */
  /* border-top: 5px rgba(0,0,0,0.5) solid; */
  box-shadow: 0 -2px 5px rgb(0,0,0);
  padding: 10px;
  
  background-image: url("/i/signup-push.jpg");
  background-size: cover;
}
.close{
  text-align: right;
  font-size: 25px;
}

.has-full-popup{
  height: 265px;
}

.margin{
  margin: 20px 10px;
}
.message{
  font-size: 20px;
}
button{
  width: 100%;
}

.popup-small{
  position: fixed;
  z-index: 50;
  left: 0;
  right: 0;
  bottom: 0;
  height: 50px;
  background-color: rgb(117, 51, 0);
  box-shadow: 0 -2px 5px rgb(0,0,0);
  padding: 13px 10px 10px 10px;
  
  background-image: url("/i/signup-push.jpg");
  background-size: cover;
  
  display: grid;
  grid-template-columns: 50% 50%;
}
.has-small-popup{
  height: 55px;
}
.login{
  grid-column: 1;
  margin-right: 5px;
}
.signup{
  grid-column: 2;
  margin-left: 5px;
}

.margin-top{
  margin-top: 20px;
}
button{
  border: none;
  color: black;
  margin-top: 20px;
  font-family: Sansation;
  font-weight: bold;
}

</style>

<Dialog title="" close="{false}" buttons="{[]}" background="{false}">
  <div class="margin-top">Log in or sign up to unlock all HOT Features!</div>
  <div><button on:click="{ () => push('/login') }">Log In</button></div>
  <div><button on:click="{ () => push('/signup/profile/type') }">Sign Up</button></div>
</Dialog>

<Header>Events</Header>

<div class="has-header"></div>

{#each items as item, index }
  
<div class="card" on:click="{ () => {popup='full'} }">
  <img src="{item.img}" alt="" class="img">
  <div class="info">
    <div class="name">{item.name}</div>
    <div><Stars stars="{item.stars}"></Stars></div>
  </div>
</div>

{/each}

<!-- {#if popup == "full"}

<div class="has-full-popup"></div>

<div class="popup">
  <div class="close" on:click="{ () => {popup=''} }"> <i class="icon-clear"></i> </div>
  <div class="margin message">Log in or sign up to unlock all Hanging Out Today's features.</div>
  <div class="margin">
    <button on:click="{ () => push('/login') }">Log In</button>
  </div>
  <div class="margin">
    <button on:click="{ () => push('/signup/profile/type') }">Sign Up</button>
  </div>
</div>

{:else}

<div class="has-small-popup"></div>

<div class="popup-small">
  <div class="login">
    <button on:click="{ () => push('/login') }">Log In</button>
  </div>
  <div class="signup">
    <button on:click="{ () => push('/signup/profile/type') }">Sign Up</button>
  </div>
</div>

{/if} -->

<script>

import {push, pop, replace, location} from 'svelte-spa-router';

import Header from "../components/Header.svelte";
import Stars from "../components/Stars.svelte";
import Dialog from "../components/Dialog.svelte";

let items = [
  {id: "abc01def", name: "Cocktail Night At The Grove - $5 Cover", stars: 4.5, img: "/i/event1.jpg"},
  {id: "def01abc", name: "Dance Party @ Club Operative", stars: 2, img: "/i/event2.jpg"},
]

let popup = "full";

</script>